import { Dispatch, SetStateAction } from "react";
import { HeaderWithFilterProps } from "../types/header-with-filter-props.type";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";
import { Check } from "lucide-react";

export const SingleFilter = ({
  item,
  selected,
  onChangePage,
  setOpen,
}: Omit<HeaderWithFilterProps, "label"> & {
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const selectedValues = selected || [];
  return (
    <Command>
      <CommandInput placeholder="Search..." className="h-9" />
      <CommandList>
        <CommandEmpty>No framework found.</CommandEmpty>
        <CommandGroup>
          {item.options?.map((item) => (
            <CommandItem
              key={item.value}
              value={item.value}
              onSelect={() => {
                const newSelected = selectedValues.includes(item.value) ? [] : [item.value];
                onChangePage(newSelected);
                setOpen(false);
              }}
            >
              {item.label}
              <Check className={cn("ml-auto", selectedValues.includes(item.value) ? "opacity-100" : "opacity-0")} />
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
};
